import React, { useContext } from 'react';
import TableContext from './TableContext';

/**
 * Table rows.
 */
export default function TableRows() {
  const {
    table: { prepareRow, page },
    props: { TableRowRenderer, TableCellRenderer },
  } = useContext(TableContext);

  return page.map((row: any, index: number) => {
    prepareRow(row);
    return (
      <TableRowRenderer
        key={index}
        row={row}
        TableCellRenderer={TableCellRenderer}
      />
    );
  });
}
